<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-75">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>{{ statInspIcon }}</md-icon>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="form-horizontal" action method="post">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <md-field>
                  <label for="type">Time Period</label>
                  <md-select
                    v-model="statInspItem.statInspItemTimePeriodId"
                    @md-selected="onTimePeriodChange"
                    :disabled="itemEditable"
                    required
                  >
                    <md-option
                      v-for="timePeriod in statInspItemTimePeriodOptions"
                      :key="timePeriod.id"
                      :value="timePeriod.id"
                      >{{ timePeriod.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <md-field>
                  <label>Reminder interval (in days)</label>
                  <md-input
                    v-model="statInspItem.reminderFrequencyInDays"
                    type="number"
                    :disabled="itemEditable"
                    required
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <md-field>
                  <label>Decription</label>
                  <md-textarea
                    v-model="statInspItem.description"
                    md-autogrow
                    required
                  ></md-textarea>
                </md-field>
              </div>
            </div>
          </form>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button
            native-type="submit"
            @click.native.prevent="onSubmit"
            class="md-success md-sm"
            :disabled="hasSubmit"
            ><md-icon class="material-icons">check</md-icon>Submit</md-button
          >
          <md-button class="md-danger md-sm" @click="onCancel"
            ><md-icon class="material-icons">close</md-icon>Cancel</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-25"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.$material.locale.dateFormat = "yyyy-MM-dd";
  },
  data() {
    return {
      hasSubmit: false
    };
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      statInspItemTimePeriodOptions: "stat-insp/statInspItemTimePeriods",
      statInspItem: "stat-insp/statInspItem"
    }),
    itemEditable() {
      return (
        this.statInspItem.statInspItemStatusId === 2 ||
        this.statInspItem.statInspItemStatusId == 3 ||
        this.statInspItem.statInspItemStatusId === 7
      );
    }
  },
  mounted() {
    if (this.statInspItem === undefined) {
      this.$store.dispatch(
        "stat-insp/getStatInspItemDetail",
        this.$route.params.statInspItemId
      );
    }
  },
  methods: {
    onTimePeriodChange(event) {
      this.SetReminderIntervalInDays(event);
    },
    SetReminderIntervalInDays(timePeriodId) {
      this.statInspItem.reminderFrequencyInDays = this.statInspItemTimePeriodOptions.find(
        timePeriod => timePeriod.id === timePeriodId
      ).intervalInDays;
    },
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("stat-insp/updateStatInspItem", {
          form: this.generateForm()
        })
        .then(() => {
          this.$router.push({
            name: "Stat Insp Item View",
            params: { statInspItemId: this.$route.params.statInspItemId }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            let validationErrorDictionary = error.response.data.errors;
            for (var fieldName in validationErrorDictionary) {
              if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                errors.push("- " + validationErrorDictionary[fieldName]);
              }
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    },
    generateForm() {
      return {
        statInspItemId: this.$route.params.statInspItemId,
        statInspItemTimePeriod: this.statInspItem
          ? this.statInspItem.statInspItemTimePeriodId
          : 1,
        reminderFrequencyInDays: this.statInspItem
          ? Number(this.statInspItem.reminderFrequencyInDays)
          : 0,
        description: this.statInspItem ? this.statInspItem.description : ""
      };
    }
  }
};
</script>

<style></style>
